import { app } from '../../../../app';
import { Controller } from './directory-list.controller';

app.component('companyDirectoryIntegrationList', {
    bindings: {directories: '<'},
    controller: Controller,
    templateUrl: require('./directory-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/list/directory-list.component.js